import { render, staticRenderFns } from "./Favlist.vue?vue&type=template&id=d88e33e8&scoped=true&"
import script from "./Favlist.vue?vue&type=script&lang=js&"
export * from "./Favlist.vue?vue&type=script&lang=js&"
import style0 from "./Favlist.vue?vue&type=style&index=0&id=d88e33e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88e33e8",
  null
  
)

export default component.exports